import { Categories } from '../constants';
import { RiskManagementRisksNamesBase } from './RiskManagementRisksNamesBase';

export class MisconfigurationsNames extends RiskManagementRisksNamesBase {
  static getExtraFilters(): Array<any> {
    return [{ category: Categories.MISCONFIGURATION }];
  }
}
